import { DataRelationPresenterModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace RelationActions {
  export class FetchRelations {
    static readonly type = '[Relation] Fetch Relations';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public payload: {
        entityId: string;
        withCount?: boolean;
        skip?: number;
        limit?: number;
      },
    ) {}
  }

  export class FetchRelation {
    static readonly type = '[Relation] Fetch Relation';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public relationId: string,
    ) {}
  }

  export class SelectRelation {
    static readonly type = '[Relation] Select Relation';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public relationId: string,
    ) {}
  }

  /**
   * fetch relations then you can read them from transitoryRelations selector.
   * here selectOnce or selectSnapshot must be used, don't use any other selection methods
   */
  export class TransitoryFetchRelations {
    static readonly type = '[Relation] TransitoryFetch Relations';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
    ) {}
  }

  export class CreateRelation {
    static readonly type = '[Relation] Create Relation';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public relation: DataRelationPresenterModel,
    ) {}
  }

  export class UpdateRelation {
    static readonly type = '[Relation] Update Relation';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public relation: DataRelationPresenterModel,
    ) {}
  }

  export class DeleteRelation {
    static readonly type = '[Relation] Delete Relation';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public relationId: string,
    ) {}
  }

  export class FetchJoinerEntityRelations {
    static readonly type = '[Relation] Fetch Joiner Entity Relations';
    constructor(
      public entitiesIds: string[],
      public operation: string,
    ) {}
  }
}
